// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3TfpH","signatureBlock":"Footer_signatureBlock__8bbMM","signature":"Footer_signature__3ZWal"};